import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';

const ActionElement = ({ className, handleOnClick, label, title }) => (
  <Grid item>
    {className === 'iconBtn' ?
      <IconButton size="small" onClick={(e) => handleOnClick(e)}>{label}</IconButton>
      :
      <Button variant="contained" size="small" color="primary" className={className} title={title} onClick={(e) => handleOnClick(e)}>
        {label}
      </Button>
    }
  </Grid>
);

ActionElement.displayName = 'ActionElement';

ActionElement.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  title: PropTypes.string
};

export default ActionElement;
